import Swal from "sweetalert2";

const CustomSwal = Swal.mixin({
  heightAuto: false,
});

export default CustomSwal;
